export const API_PATH_ApiTrafficStudiesDeviceTimezoneGet = '/services/traffic-studies/apiTrafficStudiesDeviceTimezoneGet';
